<template>
  <section class="filter-by-rate">
    <filter-rate-form
      :EBOIC="$store.getters.outputValueOfEBOIC"
      @change:EBOIC="$store.commit('inputValueOfEBOIC', parseFloat($event))"
      :ROIC="$store.getters.outputValueOfROIC"
      @change:ROIC="$store.commit('inputValueOfROIC', parseFloat($event))"
      :GPR="$store.getters.outputValueOfGrossProfitRatio"
      @change:GPR="
        $store.commit('inputValueOfGrossProfitRatio', parseFloat($event))
      "
      :ERR="$store.getters.outputValueOfExpectedRateOfReturn"
      @change:ERR="
        $store.commit('inputValueOfExpectedRateOfReturn', parseFloat($event))
      "
      :Level="$store.getters.outputValueOfSelectLevel"
      @change:Level="$store.commit('inputValueOfSelectLevel', $event)"
      :companyType="$store.getters.companyType"
      @change:companyType="$store.commit('companyType', $event)"
      :stockSymbolInForm="$store.getters.stockSymbolInForm"
      @change:stockSymbolInForm="$store.commit('stockSymbolInForm', $event)"
      @submitAllCompany="submitAllCompany"
      @submitACompanyByStock="submitACompanyByStock"
      @submitCompanyByDefault="submitCompanyByDefault"
      @submitCompanyByRatioAndDefault="submitCompanyByRatioAndDefault($event)"
    />
    <filter-rate-table
      :fields="fieldsOfFilterRate"
      :items="$store.getters.itemsOfFilterRate"
    />
  </section>
</template>

<script>
import FilterRateForm from "@/components/FilterByRate/FilterRateForm.vue";
import FilterRateTable from "@/components/FilterByRate/FilterRateTable.vue";
import { termInChinese } from "@/utility/termInChinese.js";

export default {
  name: "FilterByRate",
  components: {
    FilterRateForm,
    FilterRateTable
  },
  computed: {
    // ------------------ 篩選表格主標題區格式 ------------------

    // 因與 API 標題順序差異，無法直接使用 JS method，需對資料手動自訂排序。
    fieldsOfFilterRate() {
      return [
        "stock_symbol", //股票代號
        "company_name",
        "level",
        "go_public",
        "share_capital", //股本（元）
        "market_capital", //市值（元）
        "closing_price",
        "net_value_per_share", //每股淨值（元）
        "net_value_ratio", //淨值比
        "expected_reasonable_value", //預估每股合理價值（元）
        "consider_fund_reinvestment", //預估每股合理價值-考慮資金再投資（元）
        "discount_ratio", //折價比（%）
        "EBPR", //EBPR（元）
        // "per_share_EPS",
        "EPS_of_recently_four_seasons", //近四季每股EPS(元)
        "EPS_price_earnings_ratio", //本益比
        "EBIDTA_per_share", //每股 EBIDTA（元）
        "sum_of_EBIDTA", //近四季每股EBIDTA（元）
        // "cash_reinvestment_ratio",//現金再投資比例（%）
        // "dividend_redistribution_ratio",//現金股利分配比例（%）
        "gross_profit_ratio", //毛利率（%）
        "EBOIC",
        "ROIC"
        // "EBOE",
        // "ROE",
        // "EBOA",
        // "ROA"
      ].map(key => ({
        key,
        label: termInChinese.get(key),
        sortable: true,
        tdClass: "tdClass",
        formatter: value => {
          return value.toLocaleString().replace(/-(.+)/g, "($1)");
        }
      }));
    }
  },
  methods: {
    submitAllCompany() {
      this.resetTable();
      this.$store.dispatch("fetchAllCompany");
    },
    submitCompanyByDefault() {
      this.resetTable();
      this.$store.dispatch("fetchCompanyByDefault");
    },
    submitACompanyByStock() {
      this.resetTable();
      this.$store.dispatch("fetchACompanyByStock");
    },
    submitCompanyByRatioAndDefault(ratioQuery) {
      this.resetTable();
      this.$store.dispatch("fetchCompanyBySelectedFilterOptions", ratioQuery);
    },
    resetTable() {
      this.$store.commit("fetchFilterRate", []);
    }
  }
};
</script>

<style scoped lang="scss"></style>
